import { Link } from "react-router-dom";
import { useConsent } from "@app/state/consent.ts";

/**
 * Minibanner de cookies. La web solo usa cookies funcionales propias, así que
 * basta con un aviso compacto para decidir sobre la analítica (Google
 * Analytics), que no se carga hasta que el jugador acepta.
 */
export function CookieBanner() {
  const value = useConsent((s) => s.value);
  const open = useConsent((s) => s.open);
  const decide = useConsent((s) => s.decide);

  // En modo captura no se graba interfaz de consentimiento ni se carga analítica.
  if (__CAPTURE__) return null;
  if (!open && value !== null) return null;

  return (
    <section
      className="cookies"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookiesTitle"
      aria-describedby="cookiesText"
    >
      <p className="cookies__title" id="cookiesTitle">
        Cookies
      </p>
      <p className="cookies__text" id="cookiesText">
        Usamos cookies propias necesarias para jugar y, solo si aceptas, Google Analytics para
        medir las visitas. Puedes cambiarlo cuando quieras en la{" "}
        <Link to="/legal/cookies">política de cookies</Link>.
      </p>
      <div className="cookies__actions">
        <button type="button" className="cta cta--ghost" onClick={() => decide("denied")}>
          Rechazar
        </button>
        <button type="button" className="cta" onClick={() => decide("granted")}>
          Aceptar
        </button>
      </div>
    </section>
  );
}
